(function () {
  function initElla7MultitaskingFallbacks() {
    if (!customElements.get('side-drawer-opener')) {
      customElements.define('side-drawer-opener', class SideDrawerOpener extends HTMLElement {
        connectedCallback() {
          var button = this.querySelector('button');
          if (!button || button.dataset.srcDrawerBound === 'true') return;
          button.dataset.srcDrawerBound = 'true';
          button.addEventListener('click', () => {
            var drawer = document.querySelector(this.getAttribute('data-side-drawer'));
            if (drawer && typeof drawer.open === 'function') drawer.open(button);
          });
        }
      });
    }

    if (!customElements.get('side-drawer')) {
      customElements.define('side-drawer', class SideDrawer extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.srcMovedToBody) {
            this.dataset.srcMovedToBody = 'true';
            document.body.appendChild(this);
          }

          this.querySelector('[id^="Drawer-Overlay-"]')?.addEventListener('click', () => this.close());
          this.addEventListener('keyup', (event) => {
            if (event.code === 'Escape') this.close();
          });
        }

        open(triggeredBy) {
          this.activeElement = triggeredBy || document.activeElement;
          this.classList.add('animate', 'active', 'open');
          document.body.classList.add('overflow-hidden');
        }

        close() {
          this.classList.remove('active', 'open');
          document.body.classList.remove('overflow-hidden');
          if (this.activeElement && typeof this.activeElement.focus === 'function') this.activeElement.focus();
        }
      });
    }

    if (!customElements.get('recently-viewed-products')) {
      customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
        connectedCallback() {
          this.load();
        }

        load() {
          var url = this.getUrl();
          if (!url || /q=$/.test(url)) return;

          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              var parsed = new DOMParser().parseFromString(text, 'text/html');
              var recentlyViewed = parsed.querySelector('recently-viewed-products');
              if (recentlyViewed) this.innerHTML = recentlyViewed.innerHTML;
            })
            .catch(() => {});
        }

        getUrl() {
          var listItems = [];
          try {
            listItems = JSON.parse(localStorage.getItem('_halo_recently_viewed') || '[]');
          } catch (error) {
            listItems = [];
          }

          if (this.dataset.productId) {
            var productId = parseInt(this.dataset.productId, 10);
            listItems = listItems.filter((item) => parseInt(item, 10) !== productId);
          }

          var query = listItems
            .map((id) => 'id:' + id)
            .slice(0, parseInt(this.dataset.limit || '6', 10))
            .join('%20OR%20');

          return this.dataset.url + query;
        }
      });
    }
  }

  function applyDiscount(event) {
    var button = event.target.closest('[data-src-discount-apply]');
    if (!button) return;

    var scope = button.closest('.discount-code-field') || document;
    var input = scope.querySelector('input[name="discount"]') || document.getElementById('cart-coupon-code');
    var code = input && input.value ? input.value.trim() : '';

    if (!code) {
      if (input) input.focus();
      return;
    }

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  function syncCouponSubmit(event) {
    var input = event.target;
    if (!input || (input.id !== 'cart-coupon-code' && input.id !== 'sidebar-coupon-code')) return;
    if (event.key !== 'Enter') return;

    event.preventDefault();
    var scope = input.closest('.discount-code-field') || document;
    var button = scope.querySelector('[data-src-discount-apply]');
    if (button) button.click();
  }

  function cartCountLabel(count) {
    return count === 1 ? '1 item' : count + ' items';
  }

  function cartUnitLabel(count) {
    var item = window.cartStrings && window.cartStrings.item ? window.cartStrings.item : 'item';
    var items = window.cartStrings && window.cartStrings.items ? window.cartStrings.items : 'items';
    return count === 1 ? item : items;
  }

  function updateCartBadges(count) {
    var countLabel = cartCountLabel(count);

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });

    document.querySelectorAll('.cart-count-bubble .text, [data-cart-count-bubble] .text').forEach((element) => {
      element.textContent = count;
    });

    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach((element) => {
      element.textContent = countLabel;
    });

    document.querySelectorAll('[data-cart-text]').forEach((element) => {
      element.textContent = element.closest('.cart-count-bubble') ? countLabel : cartUnitLabel(count);
    });

    document.querySelectorAll('a.header__icon--cart, button.header__icon--cart, a.cart-icon-bubble, button.cart-icon--drawer, a.cart-icon--drawer, [data-cart-sidebar]').forEach((trigger) => {
      trigger.setAttribute('aria-label', 'Shopping Cart ' + countLabel);
    });
  }

  function refreshAndOpenCartDrawer(cart) {
    updateCartBadges(cart.item_count);

    var drawerContent = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!drawerContent) {
      document.body.classList.add('cart-sidebar-show');
      return;
    }

    drawerContent.classList.add('is-loading');

    fetch('/cart?view=ajax_side_cart', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) => response.text())
      .then((html) => {
        drawerContent.innerHTML = html;
        document.body.classList.add('cart-sidebar-show');
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      })
      .catch(() => {
        document.body.classList.add('cart-sidebar-show');
      })
      .finally(() => {
        drawerContent.classList.remove('is-loading');
      });
  }

  function handleCartUpsellSubmit(event) {
    var form = event.target.closest('[data-src-cart-upsell-form]');
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('.src-cart-upsell__button');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    var defaultText = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: new FormData(form)
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart add failed');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then((response) => response.json())
      .then((cart) => {
        refreshAndOpenCartDrawer(cart);
        button.classList.add('is-added');
        button.textContent = 'Added';
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = 'Try again';
      })
      .finally(() => {
        button.removeAttribute('aria-busy');
        if (button.classList.contains('is-added')) return;
        setTimeout(() => {
          button.textContent = defaultText;
        }, 1400);
      });
  }

  function handleBundleSubmit(event) {
    var form = event.target.closest('.frequently-bought-together-form');
    if (!form || form.dataset.srcAjaxBundle === 'false') return;

    var checkedItems = Array.from(form.querySelectorAll('.bundle-product-item')).filter((item) => {
      var checkbox = item.querySelector('.bundle-product-checkbox input[type="checkbox"]');
      return !checkbox || checkbox.checked;
    });

    var items = checkedItems.map((item) => {
      var selected = item.querySelector('select[name="group_id"]');
      var hidden = item.querySelector('input[name="group_id"]');
      var id = selected ? selected.value : hidden ? hidden.value : '';
      return id ? { id: Number(id), quantity: 1 } : null;
    }).filter(Boolean);

    if (!items.length) return;

    event.preventDefault();

    var button = form.querySelector('[data-bundle-addToCart]');
    var defaultValue = button ? button.value : '';
    if (button) {
      button.disabled = true;
      button.value = 'Adding';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Bundle add failed');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then((response) => response.json())
      .then((cart) => {
        refreshAndOpenCartDrawer(cart);
        if (button) button.value = 'Added';
      })
      .catch(() => {
        if (button) button.value = 'Try again';
      })
      .finally(() => {
        if (!button) return;
        setTimeout(() => {
          button.disabled = false;
          button.value = defaultValue;
        }, 1400);
      });
  }

  initElla7MultitaskingFallbacks();
  document.addEventListener('click', applyDiscount);
  document.addEventListener('submit', handleCartUpsellSubmit);
  document.addEventListener('submit', handleBundleSubmit, true);
  document.addEventListener('keydown', syncCouponSubmit);
})();
